// removed by extract-text-webpack-plugin
module.exports = {"title":"style__title__3XF1w","privacy":"style__privacy__2KzOj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/privacy/style.scss
// module id = 1090
// module chunks = 0